<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="create-subscription-period-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Create Subscription Period
                        </h4>
                    </div>

                    <div class="modal-body">
                        <number-form-group
                                v-model="subscriptionPeriod.price"
                                name="price"
                                label="Price"
                                :error="getError('price')"
                        ></number-form-group>

                        <date-form-group
                                v-model="subscriptionPeriod.starts_at"
                                name="starts_at"
                                label="Starts At"
                                :error="getError('starts_at')"
                                format="DD.MM.YYYY"
                        ></date-form-group>

                        <date-form-group
                                v-model="subscriptionPeriod.ends_at"
                                name="ends_at"
                                label="Ends At"
                                :error="getError('ends_at')"
                                format="DD.MM.YYYY"
                        ></date-form-group>
                        
                        <date-form-group
                                v-model="subscriptionPeriod.closes_at"
                                name="closes_at"
                                label="Closes At"
                                :error="getError('closes_at')"
                                format="DD.MM.YYYY"
                        ></date-form-group>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>

                        <button type="submit" class="btn btn-black">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import notify from '@/notify'
    import moment from 'moment'
    import Errors from '@/mixins/Errors'
    import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
    import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'

    export default {
        components: {DateFormGroup, NumberFormGroup},

        mixins: [Errors],

        props: ['subscription'],

        data() {
            return {
                subscriptionPeriod: {
                    price: this.subscription.data.price,
                    starts_at: moment().format('YYYY-MM-DD'),
                    ends_at: moment().add(this.subscription.data.period, 'months').format('YYYY-MM-DD'),
                    closes_at: moment().add(this.subscription.data.closes_after, 'days').format('YYYY-MM-DD')
                }
            }
        },

        mounted() {
            this.listenForClose()
        },

        watch: {
            'subscriptionPeriod.starts_at'(value) {
                this.subscriptionPeriod.ends_at = moment(value)
                    .add(this.subscription.data.period, 'months')
                    .format('YYYY-MM-DD')

                this.subscriptionPeriod.closes_at = moment(value)
                    .add(this.subscription.data.closes_after, 'days')
                    .format('YYYY-MM-DD')
            }
        },

        methods: {
            listenForClose() {
                $('#create-subscription-period-modal').on('hidden.bs.modal', this.reset)
            },

            submit() {
                http.post('/api/v1/subscription-periods', {
                    ...this.subscriptionPeriod,
                    subscription_id: this.subscription.data.id
                })
                    .then(response => {
                        notify.success('The subscription period was created')

                        this.$emit('created', response.data.data)

                        $('#create-subscription-period-modal').modal('hide')
                    })
                    .catch(this.catchValidationErrors)
            },

            reset() {
                this.errors = {}

                this.subscriptionPeriod = {
                    price: this.subscription.data.price,
                    starts_at: moment().format('YYYY-MM-DD'),
                    ends_at: moment().add(this.subscription.data.period - 1, 'months').format('YYYY-MM-DD'),
                    closes_at: moment().add(this.subscription.data.closes_after, 'days').format('YYYY-MM-DD')
                }
            }
        }
    }
</script>
